export default "<p>\r\n  events works!\r\n</p>\r\n";